<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="60%">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="规则名称" prop="ruleName">
            <el-input v-model="dataForm.ruleName" placeholder="规则名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规则类型" prop="ruleType">
            <el-select v-model="dataForm.ruleType" placeholder="请选择规则类型" @change="handleRuleTypeChange">
              <el-option label="产品" value="PRODUCT"></el-option>
              <el-option label="分类" value="CATEGORY"></el-option>
              <el-option label="门店" value="STORE"></el-option>
              <el-option label="角色" value="ROLE"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="目标名称" prop="targetName">
            <el-input v-model="dataForm.targetName" placeholder="目标名称" :disabled="!dataForm.ruleType"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提成类型" prop="commissionType">
            <el-select v-model="dataForm.commissionType" placeholder="请选择提成类型" @change="handleCommissionTypeChange">
              <el-option label="比例" value="PERCENTAGE"></el-option>
              <el-option label="固定" value="FIXED"></el-option>
              <el-option label="阶梯" value="TIERED"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="提成值" prop="commissionValue">
            <el-input-number 
              v-model="dataForm.commissionValue" 
              :precision="2" 
              :min="0" 
              :placeholder="dataForm.commissionType === 'PERCENTAGE' ? '提成比例(%)' : '提成金额(元)'">
            </el-input-number>
            <span v-if="dataForm.commissionType === 'PERCENTAGE'" style="margin-left: 10px;">%</span>
            <span v-else style="margin-left: 10px;">元</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="优先级" prop="priority">
            <el-input-number v-model="dataForm.priority" :min="0" placeholder="优先级"></el-input-number>
            <span style="margin-left: 10px; color: #999;">数字越大优先级越高</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="生效开始时间" prop="startTime">
            <el-date-picker
              v-model="dataForm.startTime"
              type="datetime"
              placeholder="选择生效开始时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生效结束时间" prop="endTime">
            <el-date-picker
              v-model="dataForm.endTime"
              type="datetime"
              placeholder="选择生效结束时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="状态" prop="isActive">
            <el-radio-group v-model="dataForm.isActive">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="阶梯配置" v-if="dataForm.commissionType === 'TIERED'">
        <el-input type="textarea" v-model="dataForm.tierConfig" placeholder="阶梯配置JSON" :rows="4"></el-input>
        <div style="margin-top: 10px; color: #999; font-size: 12px;">
          示例：{"tiers": [{"min": 0, "max": 1000, "rate": 5}, {"min": 1000, "max": 5000, "rate": 8}, {"min": 5000, "max": null, "rate": 10}]}
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          ruleName: '',
          ruleType: '',
          targetId: null,
          targetName: '',
          commissionType: '',
          commissionValue: 0,
          tierConfig: '',
          priority: 0,
          isActive: 1,
          startTime: '',
          endTime: ''
        },
        dataRule: {
          ruleName: [
            { required: true, message: '规则名称不能为空', trigger: 'blur' }
          ],
          ruleType: [
            { required: true, message: '规则类型不能为空', trigger: 'change' }
          ],
          targetName: [
            { required: true, message: '目标名称不能为空', trigger: 'blur' }
          ],
          commissionType: [
            { required: true, message: '提成类型不能为空', trigger: 'change' }
          ],
          commissionValue: [
            { required: true, message: '提成值不能为空', trigger: 'blur' }
          ],
          priority: [
            { required: true, message: '优先级不能为空', trigger: 'blur' }
          ],
          isActive: [
            { required: true, message: '状态不能为空', trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm = {
          id: id || 0,
          ruleName: '',
          ruleType: '',
          targetId: null,
          targetName: '',
          commissionType: '',
          commissionValue: 0,
          tierConfig: '',
          priority: 0,
          isActive: 1,
          startTime: '',
          endTime: ''
        }
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: `commission/rule/info/${this.dataForm.id}`,
              method: 'get'
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm = data.data
              }
            })
          }
        })
      },
      // 规则类型改变
      handleRuleTypeChange (type) {
        this.dataForm.targetName = ''
        this.dataForm.targetId = null
        // 这里可以根据规则类型加载对应的目标列表
        // 比如加载产品列表、分类列表等
      },
      // 提成类型改变
      handleCommissionTypeChange (type) {
        if (type !== 'TIERED') {
          this.dataForm.tierConfig = ''
        }
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: `commission/rule/${!this.dataForm.id ? 'save' : 'update'}`,
              method: 'post',
              data: {
                'id': this.dataForm.id || undefined,
                'ruleName': this.dataForm.ruleName,
                'ruleType': this.dataForm.ruleType,
                'targetId': this.dataForm.targetId,
                'targetName': this.dataForm.targetName,
                'commissionType': this.dataForm.commissionType,
                'commissionValue': this.dataForm.commissionValue,
                'tierConfig': this.dataForm.tierConfig,
                'priority': this.dataForm.priority,
                'isActive': this.dataForm.isActive,
                'startTime': this.dataForm.startTime,
                'endTime': this.dataForm.endTime
              }
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
